// extracted by mini-css-extract-plugin
export default {"loaderContainer":"AppRouter_loaderContainer__-nPs8"};